import { Typography } from "@mui/material";
import type { FC, ReactNode } from "react";
import { FONT_SIZE, INK } from "../../../theme/tokens";

/** The approval callout footer's sentence, taking the room beside its button. */
export const OutreachApprovalFooterText: FC<{ children: ReactNode }> = ({ children }) => (
	<Typography component="span" sx={{ flex: 1, minWidth: 0, fontSize: FONT_SIZE.CAPTION, lineHeight: 1.45, color: INK.SECONDARY }}>
		{children}
	</Typography>
);
